import React, { useState } from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import CobrandUnitsTable from '../Components/CobrandUnitsTable';
import DeleteModal from "../../../../Util/DeleteModal";
import { useBoolean } from '@fluentui/react-hooks';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';

const DefaultCobrandUnitsPage = () => {
    const [selectedSchool, setSelectedSchool] = useState(undefined);
    const [schoolName, setSchoolName] = useState("");
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: schools, loading }, refetch] = useAxios("/clients/schools");

    if (loading) return <Spinner className="absolute-center" label="Loading Cobrand Units..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Cobrand Unit Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <CobrandUnitsTable
                schools={schools}
                setSelectedSchool={setSelectedSchool}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                deleteOnClick={(id, unitName) => {
                    setSelectedSchool(id);
                    setSchoolName(unitName || "");
                    toggleDeleteModal();
                }}
                refetch={refetch}
                loading={loading}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`clients/schools/${selectedSchool}`}
                resourceName={schoolName}
                resourceType="school"
                confirmationValue={schoolName || undefined}
            />
        </>
    );
};

export default DefaultCobrandUnitsPage;
